import React from "react";
import { useTranslate } from "@refinedev/core";
import { Modal } from "@shared/components";
import { BookMonthForm } from "../BookMonthForm";
import { CreateBookMonthModalProps } from "./types";
import { useCreateBookMonthModal } from "./controller";

export const CreateBookMonthModal = React.memo(({ modalRef, onComplete }: CreateBookMonthModalProps) => {
  const translate = useTranslate();
  const { methods, mutateAsync, isPending } = useCreateBookMonthModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("v2/bookstore/book_month_admin.titles.create")}
      onConfirm={mutateAsync}
      methods={methods}
      isPending={isPending}
    >
      <BookMonthForm />
    </Modal>
  );
});

CreateBookMonthModal.displayName = "CreateBookMonthModal";
